(function () {
  'use strict'

  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
    )

  angular
    .module('MktzapApp.Controllers')
    .controller('ReportsInsuranceController', reports)

  reports.$inject = ['$rootScope', '$http', 'NotificationService', 'InsuranceService', 'ngTableParams', 'PartnerCompanyService']

  function reports ($rootScope, $http, NotificationService, InsuranceService, ngTableParams, PartnerCompanyService) {
    
    var vmInsurance = this
    vmInsurance.loading = false

    const HTTP_REQUEST_TIMEOUT = 408
    const HTTP_NOT_FOUND = 404

    vmInsurance.dateSelected = function (type, date) {
      if (type === 'from' && vmInsurance.pkadayToDate) {
        vmInsurance.pkadayToDate.setMinDate(date)
      }

      if (type === 'to' && vmInsurance.pkadayFromDate) {        
        vmInsurance.pkadayFromDate.setMaxDate(date);        
      }
    }

    vmInsurance.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      document: '',
      partnerCompany: '',
    }

    vmInsurance.download = function () {
            
      $http.get(apiUrl + '/reports/insurance', { params: vmInsurance.filters  })
        .then(function ({ data }) {

          if(data.success === false) {
            NotificationService.warningHandler(data, data.message);    
            return;
          }

          prepareFileForDownload(data)
          return true
        }, function ({ data, status }) {
          if (status === HTTP_REQUEST_TIMEOUT) {
            NotificationService.warningHandler(data, $rootScope.labels.alertProcessMail)
            return false
          }
          if (status === HTTP_NOT_FOUND) {
            NotificationService.warningHandler(data, $rootScope.labels.noRecordsFound)
            return false
          }
          NotificationService.errorHandler('', $rootScope.labels.errorReport)
        })
    }

    vmInsurance.search = function () {
      vmInsurance.tableAround = false;
      vmInsurance.insuranceTable = new ngTableParams({
        page: 1, // show first page
        count: 50, // count per page
        }, {
          counts: [25, 50, 100],
            getData: function ($defer, params) {
              var obj = params.url();
              obj = { count: obj['count'], 
                      params: vmInsurance.filters,
                      page: obj['page'] };

              InsuranceService
                  .paged(obj)
                  .$promise
                  .then(function (retorno) {

                    if(retorno.success === false) {
                      NotificationService.warningHandler(retorno, retorno.message);    
                      return;
                    }

                    params.total(retorno.result.total);
                    $defer.resolve(retorno.result.data);
                    vmInsurance.data_total = retorno.result.total;
                    vmInsurance.data_result = retorno.result.data.length;
                    vmInsurance.tableAround = true;
                }).catch(function (retorno) {
                  NotificationService.errorHandler(retorno);
                });
            }
      });
    }

    vmInsurance.updateStatus = function (reportItem) {
      var params = { 
        proposalNumber: reportItem.proposal_number,
        document: reportItem.document
      };

      InsuranceService.updateStatus(params)
        .$promise
        .then(function (result) {          
          
          if (!result.success) {
            NotificationService.errorHandler(result.errorMessage);
            return;
          }

          reportItem.status = result.insuranceStatus;  
        })
    }      

    vmInsurance.getPartnerCompanies = function() {

      PartnerCompanyService.getAll()
      .$promise
      .then(function (partnerCompanies) {
        
        vmInsurance.partnerCompanies = partnerCompanies;
        
      });

    }

    const prepareFileForDownload = (data) => {
      let component = angular.element('<a/>')
      component.css({ display: 'none' })
      angular.element(document.body).append(component)

      let blob = new Blob([data], { type: 'text/csv' })
      let csvUrl = URL.createObjectURL(blob)

      component.attr({
        href: csvUrl,
        target: '_self',
        download: 'insurance-report.csv'
      })[0].click()

      component.remove()
      URL.revokeObjectURL(csvUrl)

      return true
    }
    
    vmInsurance.getPartnerCompanies();
  }
})();